<template>
    <div class="d-inline-block mb-sm-0 mb-2">
        <button class="btn btn-light " @click.prevent="handleModal" ref="modifyButton">
            Modify publisher data
        </button>

        <Modal class="text-left" :title="title" :show="showModal" @close="onClose">
            <form @submit="onSubmit">
                <text-input label="List size / Impressions" name="list_size" :error="getFirstItem(errors.list_size)" v-model="form.list_size" ref="textInputRef" />
                <text-input v-if="email" label="Opens" name="opens" :error="getFirstItem(errors.opens)" v-model="form.opens" />
                <text-input v-if="landingPageUrl" label="Clicks" name="external_clicks" :error="getFirstItem(errors.external_clicks)" v-model="form.external_clicks" />
                <single-checkbox-input v-if="landingPageUrl" :class="published && !form.override_internal_clicks ? 'mb-0': ''" label="Override internally tracked clicks" name="override_internal_clicks" :error="getFirstItem(errors.override_internal_clicks)" v-model="form.override_internal_clicks" />
                <div v-if="landingPageUrl && form.override_internal_clicks">
                    <distribution-clicks :options="options" :error="getFirstItem(errors.distribution_clicks)" v-model="form.distribution_clicks"></distribution-clicks>
                    <text-input classe="datepicker" label="Placement date" name="placement_date" :error="getFirstItem(errors.placement_date)" v-model="form.placement_date" />
                    <text-input classe="datepicker" label="End date" name="end_date" :error="getFirstItem(errors.end_date)" v-model="form.end_date" />
                </div>
                <single-checkbox-input v-if="published" label="Finish advertisement" name="ad_finished" :error="getFirstItem(errors.ad_finished)" v-model="form.ad_finished" />
             </form>

            <button class="btn btn-primary" ref="submitRef" @click="onSubmit">Submit</button>
            <button class="btn btn-link" @click.prevent="onClose">Close</button>
        </Modal>
    </div>
</template>

<script>
import Modal from "./Modal";
import TextInput from './Inputs/TextInput.vue';
import GetFirstItem from '../mixins/GetFirstItem.js';
import SingleCheckboxInput from './Inputs/SingleCheckboxInput.vue';
import DistributionClicks from "./DistributionClicks.vue";

export default {
    name: "AdModifyModal",
    props: {
        route: { type: String, required: true },
        title: { type: String, default: 'Modify publisher data', required: false },
        ad: { type: Object, required: true },
        landingPageUrl: { type: Boolean, required: true},
        email: { type: Boolean, required: true},
        published: { type: Boolean, required: true},
        options: { type:Array, required:true}
    },
    components: {
        Modal,
        TextInput,
        SingleCheckboxInput,
        DistributionClicks,
    },
    mixins: [GetFirstItem],
    data() {
        return {
            showModal: false,
            form: {
                list_size: this.stringOrEmpty(this.ad.list_size),
                opens: this.stringOrEmpty(this.ad.opens),
                external_clicks: this.stringOrEmpty(this.ad.external_clicks),
                override_internal_clicks: this.ad.override_internal_clicks === 1,
                distribution_clicks: this.ad.distribution_clicks || 300,
                placement_date:  this.convertToBrusselsTime(this.ad.placement_date),
                end_date:  this.convertToBrusselsTime(this.ad.end_date),
                ad_finished: false,
            },
            errors: {},
        };
    },
    watch: {
        'form.override_internal_clicks': function(newValue, oldValue) {
            if(newValue) {
                this.$nextTick(() => {
                    $('.distribution[data-toggle="tooltip"]').each(function() {
                        if (!$(this).data('bs.tooltip')) {
                            $(this).tooltip();
                        }
                    });
                });
            }
        }
    },
    methods: {
        stringOrEmpty(value) {

            return  String(value || '');
        },
        convertToBrusselsTime(utcTimestamp) {
            if(! utcTimestamp) {

                return '';
            }

            const date = new Date(utcTimestamp);
            const options = {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric',
                timeZone: 'Europe/Brussels'
            };
            return new Intl.DateTimeFormat('nl-BE', options).format(date);
        },
        handleModal() {
            this.showModal = true;
            this.$nextTick(() => {
                this.$nextTick(() => {
                    this.$refs.textInputRef.$refs.input.focus();
                    $('.distribution[data-toggle="tooltip"]').each(function() {
                        if (!$(this).data('bs.tooltip')) {
                            $(this).tooltip();
                        }
                    });
                });
            });
        },
        onSubmit() {
            event.preventDefault();

            axios.post('/api/ad/' + this.ad.id + '/modify', this.form).then(() => {
                window.location = this.route + '?ad-modify=true';
            }).catch(error => {
                if (error.response && error.response.status == 422) {
                    this.errors = error.response.data.errors;
                }
            });
        },
        onClose() {
            this.form.list_size = this.stringOrEmpty(this.ad.list_size);
            this.form.opens = this.stringOrEmpty(this.ad.opens);
            this.form.external_clicks = this.stringOrEmpty(this.ad.external_clicks);
            this.form.override_internal_clicks = this.ad.override_internal_clicks === 1;
            this.form.distribution_clicks = this.ad.distribution_clicks || 300;
            this.form.placement_date = this.convertToBrusselsTime(this.ad.placement_date),
            this.form.end_date = this.convertToBrusselsTime(this.ad.end_date),
            this.form.ad_finished = false;
            this.showModal = false;
            this.$refs.modifyButton.focus();
        },
    },
}
</script>